import React, { useState, useEffect } from 'react';
import { AdminLayout } from '../../components/admin/AdminLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Field = ({ label, value, onChange, multiline, rows = 3 }) => (
  <div>
    <Label>{label}</Label>
    {multiline
      ? <Textarea rows={rows} value={value || ''} onChange={e => onChange(e.target.value)} className="mt-1" />
      : <Input value={value || ''} onChange={e => onChange(e.target.value)} className="mt-1" />}
  </div>
);

export const AdminHomeContent = () => {
  const [content, setContent] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/content/home`).then(r => setContent(r.data)).catch(console.error);
  }, []);

  const set = (key, val) => setContent(prev => ({ ...prev, [key]: val }));

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/content/home`, { data: content });
      toast.success('Home page updated');
    } catch { toast.error('Failed to save'); }
    finally { setSaving(false); }
  };

  if (!content) return <AdminLayout title="Edit Home Page"><div className="py-8 text-center text-gray-400">Loading...</div></AdminLayout>;

  return (
    <AdminLayout title="Edit Home Page">
      <div className="max-w-2xl space-y-6">

        <Card className="border-2">
          <CardHeader><CardTitle>Hero Section</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <Field label="Main Headline" value={content.hero_headline} onChange={v => set('hero_headline', v)} />
            <Field label="Subheadline" value={content.hero_subheadline} onChange={v => set('hero_subheadline', v)} />
            <Field label="Description" value={content.hero_description} onChange={v => set('hero_description', v)} multiline />
          </CardContent>
        </Card>

        <Card className="border-2">
          <CardHeader><CardTitle>"Why Choose Us" Section</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <Field label="Section Title" value={content.why_title} onChange={v => set('why_title', v)} />
            <Field label="Section Subtitle" value={content.why_subtitle} onChange={v => set('why_subtitle', v)} />
            {[1,2,3,4].map(n => (
              <div key={n} className="border rounded-lg p-4 space-y-2 bg-gray-50">
                <p className="text-sm font-semibold text-gray-600">Feature Card {n}</p>
                <Field label="Title" value={content[`feature_${n}_title`]} onChange={v => set(`feature_${n}_title`, v)} />
                <Field label="Description" value={content[`feature_${n}_desc`]} onChange={v => set(`feature_${n}_desc`, v)} multiline rows={2} />
              </div>
            ))}
          </CardContent>
        </Card>

        <Card className="border-2">
          <CardHeader><CardTitle>Bottom CTA Section</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <Field label="Headline" value={content.cta_headline} onChange={v => set('cta_headline', v)} />
            <Field label="Description" value={content.cta_description} onChange={v => set('cta_description', v)} multiline rows={2} />
          </CardContent>
        </Card>

        <Button onClick={save} disabled={saving} className="bg-red-600 hover:bg-red-700 text-white w-full">
          {saving ? 'Saving...' : 'Save All Changes'}
        </Button>
      </div>
    </AdminLayout>
  );
};
